import { audiApi } from "./services/audi";
import { authApi } from "./services/auth";
import { bookingApi } from "./services/booking";
import { cinemaHallApi } from "./services/cinemahall";
import { contactApi } from "./services/contact";
import { foodBookingApi } from "./services/foodbooking";
import { miscApi } from "./services/misc";
import { movieApi } from "./services/movie";
import { userAPI } from "./services/user";
import { whatsappApi } from "./services/whatsapp";

import {
  cinemaHallSlice,
  cineSettingSlice,
  configSlice,
  showSeatListSlice,
  userSlice,
} from "./slices/index";

export const reducer = {
  // slices
  [configSlice.name]: configSlice.reducer,
  [userSlice.name]: userSlice.reducer,
  [cineSettingSlice.name]: cineSettingSlice.reducer,
  [showSeatListSlice.name]: showSeatListSlice.reducer,
  [cinemaHallSlice.name]: cinemaHallSlice.reducer,

  //services
  [audiApi.reducerPath]: audiApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [bookingApi.reducerPath]: bookingApi.reducer,
  [cinemaHallApi.reducerPath]: cinemaHallApi.reducer,
  [contactApi.reducerPath]: contactApi.reducer,
  [miscApi.reducerPath]: miscApi.reducer,
  [movieApi.reducerPath]: movieApi.reducer,
  [userAPI.reducerPath]: userAPI.reducer,
  [foodBookingApi.reducerPath]: foodBookingApi.reducer,
  [whatsappApi.reducerPath]: whatsappApi.reducer,
};
